import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const ErrorContainer = styled.div`
  border-radius: ${props => props.theme.primitives.radius.radius1};
  padding: ${props => `${props.theme.spacing.sp16} ${props.theme.spacing.sp16}`};
  background-color: ${props => props.theme.colors.background.secondary};
`
